import { fasSpinnerThird } from 'shared/@generated/icons/fasSpinnerThird';
import { View } from 'react-native';
import { Text } from 'shared/components/text';
import { Icon } from 'shared/components/icon';
import { useTranslation } from 'react-i18next';
import { clsx } from 'clsx';

export const Loader = ({ dense, light }: { dense?: boolean; light?: boolean }) => {
  const { t } = useTranslation('components');

  return (
    <View
      className={clsx('items-center justify-center gap-3', {
        'flex-row p-3': dense,
        'p-6': !dense,
      })}
    >
      <Icon
        icon={fasSpinnerThird}
        className={clsx('animate-spin rounded-full', {
          'size-6': dense,
          'size-10': !dense,
          'text-brand-brown-dark bg-brand-brown-dark/5': !light,
          'text-brand-cream-light bg-brand-cream-light/15': light,
        })}
      />
      <Text
        className={clsx({
          'text-brand-brown-dark': !light,
          'text-brand-cream-light': light,
        })}
      >
        {t('loader.loading')}
      </Text>
    </View>
  );
};
